import axiosClient from '../../api/axiosClient.js';
import { fetchPageData } from '../../api/utils.js';


export async function getGames() {
  return fetchPageData(`/api/games/games/`);
}

export const gamesQuery = () => {
  return {
    queryKey: ['games'],
    queryFn: async () => getGames(),
    refetchOnWindowFocus: false,
    cacheTime: 0
  };
};

export async function getGamesSessions() {
  return fetchPageData(`/api/games/sessions/`);
}

async function getStudentGeneralInfo() {
  const { data } = await axiosClient.get(`/api/student/general-info/`);
  return data;
}

export const studentGeneralInfoQuery = () => {
  return {
    queryKey: ['generalInfo'],
    queryFn: async () => getStudentGeneralInfo(),
    refetchOnWindowFocus: false,
  };
};

async function getScenarioLevels(scenarioId) {  
  return scenarioId ? fetchPageData(`/api/games/scenario-levels/?scenarios=${scenarioId}`) : [];
}

export const scenarioLevelsQuery = (scenarioId) => {
  return {
    queryKey: ['transitionScenarioLevels', scenarioId],
    queryFn: async () => getScenarioLevels(scenarioId),
    refetchOnWindowFocus: false,
    cacheTime: 0
  };
};

export async function getClassificationDecisions({userId}) {
  return fetchPageData(`/api/classification/decisions/?user=${userId}`);
}

export async function getTransactionDecisions({userId}) {
  return fetchPageData(`/api/principles/decisions/?user=${userId}`);
}

export async function getEquationDecisions({userId}) {
  return fetchPageData(`/api/equation/decisions/?user=${userId}`);
}

export async function getNormalDecisions({userId}) {
  return fetchPageData(`/api/normal/decisions/?user=${userId}`);
}


export async function createGameSession({game, user}) {
  const body = { game, user, level1: 'not_started', is_ready: true };
  try {
    const { data } = await axiosClient.post(`/api/games/sessions/`, body);
    return data;
  } catch (err) {
    // BE partial unique index on (user, game) WHERE completed=false can surface as IntegrityError (500) on an inter-request race; one retry picks up the just-created row via the serializer's reuse path.
    if (err?.response?.status === 500) {
      const { data } = await axiosClient.post(`/api/games/sessions/`, body);
      return data;
    }
    throw err;
  }
}

async function getCourses() {
  return fetchPageData(`/api/users/courses/`);
}

export const coursesQuery = ({transitionType}) => {
  return {
    queryKey: ['transitionCourses'],
    queryFn: async () => getCourses(),
    refetchOnWindowFocus: false,
    enabled: transitionType === 'initial',
  };
};

async function getScenarioLevelsView(scenarioId) {
  const response = await axiosClient.get(`/api/games/scenario-levels/view/?scenarios=${scenarioId}`);
  return response.data;
}

export const scenarioLevelsViewQuery = (scenarioId) => {
  return {
    queryKey: ['scenarioLevelsView', scenarioId],
    queryFn: async () => getScenarioLevelsView(scenarioId),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    enabled: !!scenarioId
  };
};

async function getScenarioLevelsItemsView(scenarioId) {
  const response = await axiosClient.get(`/api/games/scenario-levels/items-view/?scenarios=${scenarioId}`);
  return response.data;
}

export const scenarioLevelsItemsViewQuery = (scenarioId) => {
  return {
    queryKey: ['scenarioLevelsItemsView', scenarioId],
    queryFn: async () => getScenarioLevelsItemsView(scenarioId),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    enabled: !!scenarioId
  };
};